<template lang="pug">
  tbody
    tr( v-for="userGroup in getList()")
      td {{userGroup.boarderGroup.name}}
      td( v-for="menuGroup in userGroup.menuGroups")
        span.active {{menuGroup.activeCount}}
      td
        span.canceled {{getCanceledReservation(userGroup)}}

</template>

<script lang="ts">
import Vue from 'vue'
import DailyReservation from '@/model/reservation/DailyReservation'
import { CURRENT_RESERVATION, CURRENT_RESERVATION_HEADER } from '@/store/getter-types'
import _ from 'lodash'

export default Vue.extend({
  name: 'ReservationTableBody',
  computed: {

    reservationData() : DailyReservation | undefined {
      return this.$store.getters[CURRENT_RESERVATION]
    }
  },
  methods: {
    getList( ): any[] {
      return this.reservationData ? this.reservationData.groupList : [];
    },

    getCanceledReservation(group:any):number{
      /*
      * group = skupina
      * */
      let canceled = 0
      let is_selected:boolean = false
      group.menuGroups.forEach( (menuGroup:any) => {

        if( !is_selected)
        {
          canceled += menuGroup.canceledCount
          is_selected = true
        }

      })

      return canceled
    }
  },


})
</script>

<style lang="stylus" scoped>

    tr
      border: 1px solid silver;
      padding: 3px 4px;

      .separator
        padding 0 10px

      .active
        color #537028

      .canceled
        color #a70000
</style>
